import { lazy } from 'react';
import { Loadable } from 'berry/components';

export const CANDIDATE_ROUTE_PREFIX = '/candidates';

const Candidates = Loadable(lazy(() => import('pages/Candidates/Candidates')));

const CandidateRoutes = [
    {
        path: `${CANDIDATE_ROUTE_PREFIX}`,
        element: <Candidates />,
        title: 'Candidates'
    },
    {
        path: `${CANDIDATE_ROUTE_PREFIX}/:candidateId`,
        element: <Candidates />,
        title: 'Candidates'
    }
];

export default CandidateRoutes;
